import { isNil } from "@s-libs/micro-dash";

import { BrowseSubjectPagesSlugs } from "@/subjects/subjects.constants";

export const findRowIndex = (list, slug) => {
  return list?.findIndex((list) => list.slug === slug);
};

export const filterContent = (content) => {
  if (isNil(content)) return null;
  const removeEmpties = content.members.filter(
    (member) => member.member_count !== 0,
  );
  const getMemberIds = removeEmpties.map((member) => member.content_id);
  return removeEmpties.filter(
    ({ content_id: contentId }, index) =>
      !getMemberIds.includes(contentId, index + 1),
  );
};

export const isBrowsePageLocked = (
  slug = "",
  { activeELALicense, activeScienceLicense, activeSSLicense, isLiteUser },
) => {
  switch (slug) {
    case BrowseSubjectPagesSlugs.ELA:
      return !isLiteUser && !activeELALicense;
    case BrowseSubjectPagesSlugs.SCIENCE:
      return !isLiteUser && !activeScienceLicense;
    case BrowseSubjectPagesSlugs.SOCIAL_STUDIES:
      return !isLiteUser && !activeSSLicense;
    default:
      return false;
  }
};
